export default function () {
  return {
    surveys: [],
    surveysCurrentPage: 1,
    surveysLastPage: 1,
    surveysPerPage: 0,
    surveysTotal: 0,
    surveysActiveTotal: 0,
    surveysLoading: false,
    indexPage: null
  }
}
